
import { lazy, ComponentType, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

// Error boundary component for lazy loaded routes
const LazyRouteErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {children}
    </Suspense>
  );
};

// Helper function to create lazy-loaded components with error handling
const lazyLoad = <T extends ComponentType<any>>(importFunc: () => Promise<{ default: T }>) => {
  return lazy(() => 
    importFunc().catch((error) => {
      console.error('Failed to load component:', error);
      // Return a default error component
      return {
        default: () => <div>Error loading page. Please try again.</div>
      };
    })
  );
};

const HomePage = lazyLoad(() => import('../pages/home/page'));
const QuienesSomosPage = lazyLoad(() => import('../pages/quienes-somos/page'));
const ColegiosPage = lazyLoad(() => import('../pages/colegios/page'));
const ActividadesPage = lazyLoad(() => import('../pages/actividades/page'));
const RecursosPage = lazyLoad(() => import('../pages/recursos/page'));
const GaleriaPage = lazyLoad(() => import('../pages/galeria/page'));
const ContactoPage = lazyLoad(() => import('../pages/contacto/page'));
const NotFoundPage = lazyLoad(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LazyRouteErrorBoundary><HomePage /></LazyRouteErrorBoundary>,
  },
  {
    path: '/quienes-somos',
    element: <LazyRouteErrorBoundary><QuienesSomosPage /></LazyRouteErrorBoundary>,
  },
  {
    path: '/colegios',
    element: <LazyRouteErrorBoundary><ColegiosPage /></LazyRouteErrorBoundary>,
  },
  {
    path: '/actividades',
    element: <LazyRouteErrorBoundary><ActividadesPage /></LazyRouteErrorBoundary>,
  },
  {
    path: '/recursos',
    element: <LazyRouteErrorBoundary><RecursosPage /></LazyRouteErrorBoundary>,
  },
  {
    path: '/galeria',
    element: <LazyRouteErrorBoundary><GaleriaPage /></LazyRouteErrorBoundary>,
  },
  {
    path: '/contacto',
    element: <LazyRouteErrorBoundary><ContactoPage /></LazyRouteErrorBoundary>,
  },
  {
    path: '*',
    element: <LazyRouteErrorBoundary><NotFoundPage /></LazyRouteErrorBoundary>,
  },
];

export default routes;
